module.exports = __webpack_public_path__ + "media/video-1.8eb56c61.mp4";